import React ,{Component} from 'react'; 

import axios from 'axios'; 
import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Select from '@mui/material/Select';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {DropzoneArea} from 'material-ui-dropzone'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { addDays } from "date-fns";
import DangerousIcon from '@mui/icons-material/Dangerous';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { makeStyles } from '@mui/styles'; 

import Checkbox from '@mui/material/Checkbox';
const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
export default class  AddNotificationbox extends Component {

  constructor(props) {
      super(props)
	  var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	
      this.state = {
		  
		   open:false,title:'',no_id:0,no_type:0,no_classtype:'',classtype:[],ispanel:false,imgfile:'',remainderdate:0,description:'',optiontype:'',prevca_icon:'',imgCollection:'',errormessage:'',erropen:false,classesarray:[],classes:'',rolelabel:'Select Class',staffarray:[],staff:'',
		   yearsarray:[],years:'',batcharray:[],batch:'',brancharray:[],branch:'',typerecordid:0,
			studentarray:[],student:'',nodate:Date.now(),nodate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),rmdate:Date.now(),rmdate1:'',no_classtype1:false,no_classtype6:false,no_classtype2:false,no_classtype3:false,no_classtype4:false,no_classtype5:false,
	  }
      
  }
handleNotifypanel=()=>{
	this.setState({ ispanel:!this.state.ispanel});  
	  
}
handfrChanges = (date) => {
	
	  var month="";
	   var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	
     this.setState({ rmdate:dayjs(date),
rmdate1:date.getFullYear() + '-' + month + '-' +date.getDate()+' '+date.getHours()+':'+date.getMinutes()+":00"
	 })
	
	
  }
  handnodateChanges = (date) => {
	
	  var month="";
	   date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	
     this.setState({ nodate:dayjs(date),rmdate: date.setDate(date.getDate() - 1),
nodate1:date.getFullYear() + '-' + month + '-' +date.getDate(),
rmdate1:date.getFullYear() + '-' + month + '-' +date.getDate()+' 09:'+date.getMinutes()+":00"
	 })
	
	
  }  
  

 Downloadsgetdata() {
	var self=this;
  if(this.props.id!==0)
  {
	  
	   axios.get(Serverurl+'ajaxnotifications.php?action=getall&no_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
		
		if(resp.data[0].no_classtype!="")
	{
		let strarrclass=[],no_classtype1=false,no_classtype2=false,no_classtype3=false,no_classtype4=false,no_classtype5=false,no_classtype6=false;
	var strarr=resp.data[0].no_classtype.split(',');
	
	 var subnewRow = strarr.map((rowssub, j) => { 
	 strarrclass.push(rowssub[0]);
	 
	 if(rowssub[0]=="1")
	 {
		 no_classtype1=true
	 }
	else if(rowssub[0]=="2")
	 {
		 no_classtype2=true
	 } else if(rowssub[0]=="3")
	 {
		 no_classtype3=true
	 }
	 else if(rowssub[0]=="4")
	 {
		 no_classtype4=true
	 }
	  else if(rowssub[0]=="5")
	 {
		 no_classtype5=true
	 }
	 else if(rowssub[0]=="6")
	 {
		 no_classtype6=true
	 }
	 
	 });

	 this.setState({classtype:strarrclass,no_classtype1:no_classtype1,no_classtype2:no_classtype2,no_classtype3:no_classtype3,no_classtype4:no_classtype4,no_classtype5:no_classtype5,no_classtype6:no_classtype6})
	 }
   setTimeout(function(){ self.setState({ 
     
      no_id:resp.data[0].no_id,
	  title: resp.data[0].no_title,
   
	 file: resp.data[0].no_file,   
	 prevca_icon: resp.data[0].no_file,
	 rmdate1: resp.data[0].no_remiderdate,
	 description:resp.data[0].no_description, 
	 rmdate:resp.data[0].no_remiderdate,
	 nodate:resp.data[0].start,nodate1:resp.data[0].start,
	 
	 no_type:resp.data[0].no_type,
	 optiontype:resp.data[0].no_optiontype,

	  
    });
	
	 if(resp.data[0].no_optiontype==="2")
	 {
		 self.setState({staff: resp.data[0].no_classtype });
	 }
	 else if(resp.data[0].no_type==="2")
	 {
		self.setState({ no_classtype:resp.data[0].no_classtype });
	 }
	
	
	 }, 1500);
	
  }  
});
	
  }else{
	 this.setState({  
	  no_id:0,
	  title: '',
      optiontype: '', 
	 file: '',   
	 prevca_icon:'',
	
	 description:'', 
	 
	
	 
	  }); 
 }
  
    }

  handleactivecustomer= (event) => {
	
	 this.setState({optiontype: event.target.value});
		
} 
handleprefernec = (event) => {
	
	// this.setState({no_classtype: event.target.value});
		let strclasstype=[...this.state.classtype,event.target.name]
	let no_classtype1=false,no_classtype2=false,no_classtype3=false,no_classtype4=false,no_classtype5=false, no_classtype6=false;
 if (this.state.classtype.includes(event.target.name)) {
	
      strclasstype = strclasstype.filter(day => day !== event.target.name);
	  
	   
    }
		
	 var subnewRow = strclasstype.map((rowssub, j) => { 
	
	 if(rowssub[0]=="1")
	 {
		 no_classtype1=true
	 }
	else if(rowssub[0]=="2")
	 {
		 no_classtype2=true
	 } else if(rowssub[0]=="3")
	 {
		 no_classtype3=true
	 }
	 else if(rowssub[0]=="4")
	 {
		 no_classtype4=true
	 }
	  else if(rowssub[0]=="5")
	 {
		 no_classtype5=true
	 }
	  else if(rowssub[0]=="6")
	 {
		 no_classtype6=true
	 }
	 });

	 this.setState({classtype:strclasstype,no_classtype1:no_classtype1,no_classtype2:no_classtype2,no_classtype3:no_classtype3,no_classtype4:no_classtype4,no_classtype5:no_classtype5,no_classtype6:no_classtype6},()=>{
			 
			
		 })
 
	console.log(strclasstype)
}  
  handleradChange= (event) => {
	
	 this.setState({no_type: event.target.value});
	 
	 if(event.target.value==="1")
	 {
		 this.onloadStaffbind();
	 }
	
}
handleClickOpen = (e) => {
	 var rmdate = new Date(this.props.edate), month="";
	
	  
rmdate.setDate(rmdate.getDate() + - 1);
	
	 if((rmdate.getMonth() + 1)<10)
	 {
		month="0"+ (rmdate.getMonth() + 1)		 
	 }else{month=(rmdate.getMonth() + 1)}   
	
  this.setState({open:!this.state.open,ispanel:false,nobtndisable:false,notbtnSave:'Save',  title:'',address:'',remainderdate:'',errormessage:'',erropen:false,classesarray:[],classes:'',staff:'0',no_type:0,no_classtype:0,optionstype:'',
  branch:'',batch:'',student:'',rmdate1:rmdate.getFullYear() + '-' + month + '-' +rmdate.getDate()+' 09:'+rmdate.getMinutes()+":00",rmdate:rmdate,nodate:this.props.edate,nodate1:this.props.celldate,no_classtype1:false,no_classtype6:false,no_classtype2:false,no_classtype3:false,no_classtype4:false,no_classtype5:false,classtype:[],
	  });this.onloadStaffbind();
		this.Downloadsgetdata();
		
	
		
	
		
		};
myChangeHandler = (event) => {
	
	 
  let nam = event.target.name;
  let val = event.target.value;  
 
  this.setState({[nam]: val});
  }
  


 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
  onloadStaffbind(){

    axios.get(Serverurl+'ajaxstaff.php?action=getall&st_role=3')
	
    
      .then((response) => {    
     
      this.setState({  staffarray: response.data,  },()=>{
		  
		  let roleFromApi = this.state.staffarray.map(st => {
                            
          return {value: st.st_id, display:st.st_name}
        });
      
		
        this.setState({
          staffarray: [{value: '0', display: 'All'}].concat(roleFromApi)
        });
		  
		  
	  });
      })   
    
     


} 
 

handleClose = (e) => {
	
	
 let title = this.state.title;
 let description=this.state.description;
let optiontype=this.state.optiontype;
 let imgfile=this.state.imgfile;
let rmdate1=this.state.rmdate1;

let no_classtype=this.state.no_classtype;
let nodate1=this.state.nodate1;

let strsep="",strclass="";
 var subnewRow = this.state.classtype.map((rowssub, j) => { 

strclass=strclass+strsep+rowssub[0];
strsep=",";
 });
if(title==="")
{
	
	this.setState({errormessage:"Please Enter Title",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if( this.state.no_type==="" || this.state.no_type==="0")
{
	this.setState({errormessage:"Please Select  Staff/Customer",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}
if( this.state.no_type==="2")
{
			
	if(optiontype==="")
	{
		
		this.setState({errormessage:"Please Select Option Type",erropen:true});
			 window.scrollTo({
			  top: 0
		  })
			 return false;
		
		
	}
	if(strclass==="")
	{
		
		this.setState({errormessage:"Please Select Preference",erropen:true});
			 window.scrollTo({
			  top: 0
		  })
			 return false;
		
		
	}
	
	
}
if( description==="" )
{
	this.setState({errormessage:"Please Enter  Description",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}

this.setState({errormessage:"",erropen:false,nobtndisable:true,notbtnSave:'Processing...'});

   var formData = new FormData();
  
  
   if(this.state.no_id===0)
	  {
		  formData.append('no_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('no_id',this.state.no_id)
		
      }	  

        formData.append('action','insertorupdate') 
		formData.append('no_remiderdate',rmdate1)
			formData.append('no_date',nodate1)
		formData.append('no_title',title)
		formData.append('no_description',description)		
	
			if(imgfile!=="")
			{
				formData.append('file',"1") 
		  formData.append('Filedata', this.state.imgfile[0])
		  }
		 else if(this.state.prevca_icon!=="")
			{
				formData.append('previcon',this.state.prevca_icon) 
			}
		  else{
			 formData.append('file',"") 
		  }
		  
	  formData.append('no_type',this.state.no_type)
		
		
		formData.append('userid',localStorage.getItem("AYLuserid"))
		
		
		
			if(this.state.no_type==="1" && this.state.staff!=="")
		{
			formData.append('no_classtype',this.state.staff)
			formData.append('no_optiontype',2)
		}
		
			else if(this.state.no_type==="1" && this.state.staff==="0")
		{
			formData.append('no_optiontype',1)
			formData.append('no_classtype',0)
		}
		
		else if(this.state.no_type==="2" )
		{
			formData.append('no_optiontype',optiontype)
			formData.append('no_classtype',strclass)
		}
		//formData.append('userid',localStorage.getItem("MMCuserid"))
		  
		axios.post(Serverurl+"ajaxnotifications.php", formData, {
        }).then(res => {
    
	
	
	if(res.data === -1)
{ 
	 

		this.setState({errormessage:"Title Already Exist.",erropen:true,open:true,nobtndisable:true,notbtnSave:'Processing...'
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}else{
		this.setState({errormessage:"",erropen:false,nobtndisable:true,notbtnSave:'Processing...'});
	}
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
	 
  } 
	
	
	 
NotificationDelete(noid){  

let r = window.confirm("Do you really want to delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();

     formData.append('action','delete')
	 
	 formData.append('no_id',noid)
	 
		   
formData.append('userid',localStorage.getItem("AYLuserid"))	
	
	 axios.post(Serverurl+"ajaxnotifications.php", formData, {
        }).then(res => {
					
					this.setState({ open:false });
   
					
							});
	  
 }
	
   }

render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title" className="dwnloadspanel">
      <DialogTitle id="form-dialog-title"> 
	   <div className="ntfnheading"><h2>Notifications</h2></div>
	    <div className="closeicon"   onClick={this.handleClickOpen} > {<DangerousIcon/>}</div> 
	   <div className="clear"></div>
	  </DialogTitle>
      <DialogContent>
	  
<div className="formlists">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
		
	
	
	
	 <p><span className="validation">*</span> Date
		
	
	<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.nodate) }
className="txtbox" minDate={dayjs(Date.now()) }
    onChange={this.handnodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
	</p>
		
		
		  
	
						  
	<p> <span className="validation">*</span> Title</p>
	
	<p><TextField name="title" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.title}
			 className="txtbox"
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
	 <p><FormControl>
      <FormLabel id="optionstype"></FormLabel>
      <RadioGroup
        row value={this.state.no_type}
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="no_type" onChange={this.handleradChange}
      >
	  <FormControlLabel value="1" control={<Radio />} label="Staff"  checked={this.state.no_type === "1"}/>
        <FormControlLabel value="2" control={<Radio />} label="Customer"  checked={this.state.no_type === "2"}/>
		

        
      </RadioGroup>
    </FormControl></p>
	{this.state.no_type==="2" &&(<div>
	<p><span className="validation">*</span>Customer Type</p>
	 <p><FormControl>
      <FormLabel id="optionstype"></FormLabel>
      <RadioGroup
        row value={this.state.optiontype}
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="optiontype" onChange={this.handleactivecustomer}
      >
	  <FormControlLabel value="1" control={<Radio />} label="Active"  checked={this.state.optiontype === "1"}/>
        <FormControlLabel value="2" control={<Radio />} label="Inactive"  checked={this.state.optiontype === "2"}/>
		

        
      </RadioGroup>
    </FormControl></p>
	<p><span className="validation">*</span>Select Your Preference</p>
	 <p>
	 
	  <Checkbox id="classtype1" name="1" onChange={this.handleprefernec} checked={this.state.no_classtype1} /> Personal Training at Home
        <Checkbox id="classtype2" name="2" onChange={this.handleprefernec}  checked={this.state.no_classtype2}/> Personal Training in Studio<br/>
       <Checkbox id="classtype3" name="3" onChange={this.handleprefernec} checked={this.state.no_classtype3}/> Group
        <Checkbox  id="classtype4" name="4" onChange={this.handleprefernec} checked={this.state.no_classtype4}/> Prenatal
		
		<Checkbox  id="classtype6" name="6" onChange={this.handleprefernec} checked={this.state.no_classtype6}/> Personal Training Online
	</p>
	
	</div>)}
	
	{this.state.no_type!=="" &&(
	<div className="optionstypedrp">
	{this.state.no_type==="1" &&(<React.Fragment><p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 className="txtbox"
		  inputProps={{tabIndex: "2"}} 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.staff }}
          onChange={this.myChangeHandler}
          id="staff"
		   value={this.state.staff}
		  name="staff"
		
		
        >
		{this.state.staffarray.map(staff => (
            <option  
            
              value={staff.value}
            >
              {staff.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
	
			  
			  </React.Fragment>)}
	  
	
				
			

	
</div>)}



<p> <span className="validation">*</span> Description</p>
	
	<p><TextField name="description" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
          rows={4}
	   value={this.state.description}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "4"}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
			<p className="searchbutton">	

<Button variant="contained" onClick={this.handleNotifypanel} className={useStyles.submit} startIcon={<ReadMoreIcon />}>
        More Option
      </Button></p>
	

<div className="clear"></div>

{this.state.ispanel && (<React.Fragment>	
	
	
	
	 <p>Remainder Date
		
	<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DateTimePicker']}>
<DateTimePicker
 viewRenderers={{
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
            seconds: renderTimeViewClock,
          }}
value= {dayjs(this.state.rmdate) }
className="txtbox" minDate={dayjs(Date.now()) }
    onChange={this.handfrChanges} 
/>  </DemoContainer>
    </LocalizationProvider>
	</p>
		
		
	</React.Fragment>	)}

{this.state.ispanel && (<React.Fragment>	

<div >
	<DropzoneArea dropzoneText="Upload/Browse Files"   maxFileSize={5000000} Icon={CloudUploadIcon} dropzoneClass="filesupld" filesLimit={1} acceptedFiles={['application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/pdf,image/jpeg,image/jpg,image/png,image/gif']}
  onChange={(files) => {console.log('Files:', files);

  var _URL = window.URL || window.webkitURL;
  this.setState({ imgfile: files })
  }
  }
   
/>
	{this.state.prevca_icon!=='' && (
		
			<a href={Serverurl+"uploads/"+this.state.prevca_icon} rel="noreferrer" target='_blank'>View</a>
	)}
	</div>
	</React.Fragment>	)}
	
	<div className="clear"></div>
		
       <div className="actionbtn">
<div className="cancelbtn">	  
{this.props.id!==0 && (
		<Button onClick={()=>{this.NotificationDelete(this.props.id)}} className="frmthirdbtn">
          Delete
        </Button>
)}
		</div> 
<div className="savebtn">
        <Button onClick={this.handleClose} disable={this.state.nobtndisable} className="frmSecondarybtn">
			{this.state.notbtnSave}
        </Button>
		</div>
<div className="clear"></div>
</div> 
     
	</div>		 
	 </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
} 
  









